/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Sort_By_Priority_AriaInputs */

const en_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const fr_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const de_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const it_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const ru_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const es_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const zh_cn2_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const ja_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const hi_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

const pt_pt2_explorer_table_sort_by_priority_aria = /** @type {(inputs: Explorer_Table_Sort_By_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by priority`)
};

/**
* | output |
* | --- |
* | "Sort by priority" |
*
* @param {Explorer_Table_Sort_By_Priority_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_sort_by_priority_aria = /** @type {((inputs?: Explorer_Table_Sort_By_Priority_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Sort_By_Priority_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "de") return de_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "it") return it_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "ru") return ru_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "es") return es_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "ja") return ja_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "hi") return hi_explorer_table_sort_by_priority_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_sort_by_priority_aria(inputs)
	return en_explorer_table_sort_by_priority_aria(inputs)
});